export default __webpack_public_path__ + "static/media/bscs-logo.1632c49c.png";